export default __webpack_public_path__ + "static/media/doctor-3.77b8295d.jpg";